export interface Input extends Marko.SVG.SVG {}

<svg ...input width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
        d="M4.29289 10.7071C4.29275 10.707 4.29303 10.7072 4.29289 10.7071C4.04882 10.463 3.95729 10.1242 4.01831 9.80901C4.05492 9.61991 4.14645 9.43934 4.29289 9.29289L11.2929 2.29289C11.6834 1.90237 12.3166 1.90237 12.7071 2.29289C13.0976 2.68342 13.0976 3.31658 12.7071 3.70711L6.41421 10L12.7071 16.2929C13.0976 16.6834 13.0976 17.3166 12.7071 17.7071C12.3166 18.0976 11.6834 18.0976 11.2929 17.7071L4.29289 10.7071Z"
        fill="currentColor"/>
</svg>
